<template>
  <div class="mobile-view" style="position: relative">
    <div class="mobile-view-frame color-gradient" />
    <img class="mobile-view-image" :src="mobileBackground" />
    <div class="mobile-view-camera" />
    <div class="mobile-view-bar mobile-view-bar-top" />
    <div class="mobile-view-bar mobile-view-bar-bottom" />
    <div class="mobile-view-clock">
      <span class="mobile-view-clock-large">{{ format(now, "HH:mm") }}</span>
      <br />
      <span class="mobile-view-clock-small">{{
        format(now, "eeee, d LLLL")
      }}</span>
      <br />
    </div>
    <!-- Beginning of notificiation -->
    <div class="mobile-view-notification rotate-in" v-if="title || message">
      <div class="mobile-view-notification-top-bar">
        <img
          class="mobile-view-notification-app-icon"
          src="https://covatic.com/wp-content/uploads/2021/03/Favicon-Logo-Light.svg"
        />
        <span class="mobile-view-notification-app-name">APP NAME</span>
        <span class="mobile-view-notification-relative-arrival-time">now</span>
      </div>
      <div class="mobile-view-notification-body">
      <div>

        <div class="mobile-view-notification-title">
          {{ title }}
        </div>
        <div class="mobile-view-notification-text">
          {{ message }}
        </div>
      </div>
        <img v-if="image" class="mobile-view-notification-image" :src="image" />
      </div>
    </div>
    <!-- End of notification -->
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "MobileView",
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      destroyed: false,
      now: null,
      format,
    };
  },
  created() {
    this.updateClock();
  },
  destroyed() {
    this.destroyed = true;
  },
  computed: {
    title() {
      return this.payload?.title ?? "";
    },
    message() {
      return this.payload?.message ?? "";
    },
    image() {
      return this.payload?.image;
    },
    mobileBackground() {
      return require("@/assets/MobileBackground.png");
    },
    notificationIcon() {
      return require("@/assets/Covatic.png");
    },
  },
  methods: {
    updateClock() {
      if (this.destroyed) return;
      this.now = new Date();
      setTimeout(this.updateClock, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/main.sass";

.mobile-view {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif;
  width: 100%;
  height: 100%;
}

.mobile-view-frame {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: map-get($grey, darken-4) 2px solid;
  border-radius: 30px;
}

.mobile-view-image {
  position: absolute;
  top: 10%;
  right: 5%;
  width: 90%;
  height: 80%;
  border: map-get($grey, darken-4) 2px solid;
  border-radius: 2px;
}

.mobile-view-camera {
  position: absolute;
  top: 4%;
  left: 17.5%;
  width: 15px;
  height: 15px;
  background: #111;
  border: map-get($grey, darken-3) 1.5px solid;
  border-radius: 7.5px;
}

.mobile-view-bar {
  position: absolute;
  left: 30%;
  width: 40%;
  height: 10px;
  background: #333;
  border: map-get($grey, darken-4) 1.5px solid;
  border-radius: 5px;
}

.mobile-view-bar-top {
  top: calc(4% + 2.5px);
  background-color: #AAAAAA;
}

.mobile-view-bar-bottom {
  bottom: calc(4% + 2.5px);
  background-color: #AAAAAA;
}

.mobile-view-clock {
  position: absolute;
  color: #eee;
  left: 0;
  top: 22.5%;
  width: 100%;
  height: 20px;
  font-family: "Open Sans", sans-serif;
  text-align: center;
  line-height: 26px;
}

.mobile-view-clock-large {
  font-size: 60px;
}

.mobile-view-clock-small {
  font-size: 16px;
}

.mobile-view-notification-app-icon {
  position: relative;
  left: 0;
  top: 0;
  border-radius: 4px;
  width: 20px;
  height: 20px;
}

.mobile-view-notification-top-bar {
  position: relative;
  left: 0;
  text-align: left;
}

.mobile-view-notification-app-name {
  position: absolute;
  margin: 0;
  padding: 0;
  left: 26px;
  bottom: 5px;
  color: #838383;
  font-size: 13px;
}

.mobile-view-notification-relative-arrival-time {
  position: absolute;
  right: 0;
  bottom: 5px;
  margin-right: 6px;
  color: #838383;
  font-size: 13px;
}

.mobile-view-notification {
  position: absolute;
  left: 10%;
  right: 10%;
  top: calc(22.5% + 85px);
  // min-height: 112px;
  text-align: center;
  line-height: 26px;
  background-color: #ddd;
  border-radius: 13px;
  padding: 10px;
}

.mobile-view-notification-image {
  position: relative;
  top: 0;
  right: 25px;
  height: 36px;
  width: 36px;
  background-color: #888;
  border-radius: 4px;
  object-fit: cover;
}

.mobile-view-notification-body {
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
}
.mobile-view-notification-title {
  position: relative;
  left: 0;
  top: 0;
  font-weight: 700;
  width: 250px;
  margin: 0;
  font-size: 15px;
  color: #000;
  text-align: left;
  white-space: normal;
  line-height: 20px;
}

.mobile-view-notification-text {
  width: 250px;
  text-overflow: ellipsis;
  margin: 0;
  font-size: 15px;
  color: #000;
  text-align: left;
  white-space: normal;
  line-height: 18px;
  overflow: hidden;
}

.color-gradient {
  background: #333;
  background: -webkit-linear-gradient(
    to bottom right,
    #DDDDDD,
    #EEEEEE,
    #DDDDDD
  ); /* Chrome10+, Safari5.1+ */
  background: -moz-linear-gradient(
    to bottom right,
    #DDDDDD,
    #EEEEEE,
    #DDDDDD
  ); /* FF3.6+ */
  background: linear-gradient(to bottom right, #DDDDDD, #EEEEEE, #DDDDDD);
}
</style>
